import { Form, Input, Typography } from 'antd';
import { Heading } from '../Heading';
import { Card } from '../Card';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const OrderIdCard = () => {
  const { t } = useTranslation();

  return (
    <Card>
      <Heading
        title={t('custom_id')}
        fontSize='text-xs'
        fontWeight='font-bold'
        color='text-sd-muted-foreground'
        extraClassName='uppercase tracking-wider mb-1'
      />
      <Text className='text-xs text-sd-muted-foreground mb-3 block'>{t('if_you_do_not')}</Text>
      <Form.Item name='orderId' className='mb-0'>
        <Input
          autoComplete='off'
          className='h-[40px] rounded-md border border-solid border-sd-input bg-sd-input-bg focus-visible:ring-2 focus-visible:ring-sd-ring focus-visible:ring-offset-2'
          placeholder={t('order_id_custom')}
        />
      </Form.Item>
    </Card>
  );
};

export default OrderIdCard;
